import React, { useState } from 'react';
import SEO from '@components/SEO';
import { useNavigate } from 'react-router-dom';
import { Styles } from './styles';
import { TextField, Button, Typography, Box } from '@mui/material';
import Logo from '@assets/images/Logotipo/Elite Prime_Logo_FundoPreto.png';

const RecoveryPassScreen: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Email enviado para:', email);
    setIsSubmitted(true);
  };

  return (
    <Styles.PageContainer>
      <SEO title="Recuperar Senha" noIndex />
      <Styles.LeftPanel>
        <Styles.ImageOverlay />
        <Box position="relative" zIndex={2} textAlign="center">
          <Typography variant="h4" color="white" gutterBottom>
            Recuperação de Senha
          </Typography>
          <Typography variant="body1" color="white">
            Entre em contato se precisar de ajuda adicional
          </Typography>
        </Box>
      </Styles.LeftPanel>
      <Styles.RightPanel>
        <Styles.FormContainer>
          <Styles.LogoContainer>
            <img
              src={Logo}
              alt="Elite Prime Logo"
              style={{ maxWidth: '200px' }}
            />
          </Styles.LogoContainer>
          {isSubmitted ? (
            <>
              <Styles.SuccessMessage>
                <Typography variant="body1">
                  Um email com instruções para redefinir sua senha foi enviado
                  para {email}
                </Typography>
              </Styles.SuccessMessage>
              <Button
                fullWidth
                variant="contained"
                sx={Styles.SubmitButton}
                onClick={() => navigate('/login')}>
                Voltar para o Login
              </Button>
            </>
          ) : (
            <>
              <Styles.Title variant="h5">Recuperar Senha</Styles.Title>
              <Styles.Description variant="body1">
                Digite o email associado à sua conta e enviaremos um link para
                redefinir sua senha.
              </Styles.Description>

              <Styles.Form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  sx={Styles.TextField}
                  margin="normal"
                />

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={Styles.SubmitButton}>
                  Enviar Instruções
                </Button>
              </Styles.Form>
              <Styles.BackToLogin>
                <Typography variant="body2">
                  Lembrou sua senha?{' '}
                  <a
                    href="/login"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/login');
                    }}>
                    Faça login
                  </a>
                </Typography>
              </Styles.BackToLogin>
            </>
          )}
        </Styles.FormContainer>
      </Styles.RightPanel>
    </Styles.PageContainer>
  );
};

export default RecoveryPassScreen;
